import { ServiceTokens } from "$src/domain/ServiceTokens";
import type { IStoreRepository } from "$src/domain/directory/stores/IStoreRepository";
import { Store } from "$src/domain/directory/stores/Store";
import { inject, injectable } from "tsyringe";

@injectable()
export class GetStoreById {
    
    constructor(@inject(ServiceTokens.StoreRepository) private storeRepository: IStoreRepository) {}

    async execute(groupStoreId: number, storeId: number): Promise<Store> {
        return await this.storeRepository.getStoreById(groupStoreId, storeId);
    }
}

export const GetStoreByIdToken = Symbol('GetStoreByIdToken');    
